module.exports = __webpack_public_path__ + "img/vg.d0636537.svg";